import React, { useState } from "react";
import {
  Mockup,
  blueMsg,
  People,
  GirlInWhite,
} from "../../assets/images";
import {
  DefaultSplashScreen,
  FirstSplashScreen,
  SecondSplashScreen,
  ThirdSplashScreen,
} from "..";

type SplashScreenProps = {
  handleContinue: () => void;
};
const SplashScreen: React.FC<SplashScreenProps> = ({ handleContinue }) => {
  const images = [Mockup, People, GirlInWhite];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentImageIndex(
        (prevIndex: number) => (prevIndex + 1) % images.length
      );
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(intervalId); // Clear interval on component unmount
  }, [images.length]);

  
  const [currentComponentIndex, setCurrentComponentIndex] = useState(0);

  const handleNext = () => {
    setCurrentComponentIndex((prevIndex) =>
      prevIndex === components.length - 1 ? 0 : prevIndex + 1
    );
  };

  const components = [
    <DefaultSplashScreen handleNext={handleNext} />,
    <FirstSplashScreen handleNext={handleNext} />,
    <SecondSplashScreen handleNext={handleNext} />,
    <ThirdSplashScreen handleContinue={handleContinue} />,
  ];
  
  return (
    <div className="flex w-full bg-white inset-0 z-50 items-center justify-center fixed overflow-hidden">
      {components[currentComponentIndex]}

      <div className="hidden w-[55%] pl-[110px] lg:flex flex-col font-BRFirma z-30">
        <div className="font-bold text-midGreen text-[55px] leading-none">
          Welcome <br /> to Ecobook.
        </div>
        <p className="text-[20px] font-medium text-[#8A97A0] break-words whitespace-pre-line text-pretty mt-3">
          The town square for the Ecomoto <br /> community-lessors and lessees.
          <br />
          <br />
          Here, you can socialize, network, and share <br /> content (video,
          pictures, infographics, etc.)
        </p>
        <div
          className="mt-4 items-center cursor-pointer bg-midGreen flex justify-center text-center font-Poppins font-medium text-lg w-[335px] h-[50px] text-white rounded-2xl"
          onClick={handleContinue}
        >
          Continue
        </div>
      </div>
      <div className="lg:flex hidden w-[45%] justify-center items-center bg-midGreen h-[100%]">
        <div
          className={`bg-no-repeat h-[100%] w-full bg-center bg-contain ${
            currentImageIndex === 1 ? "bg-cover" : ""
          }`}
          style={{ backgroundImage: `url(${images[currentImageIndex]})` }}
        ></div>{" "}
      </div>
      <div className="hidden lg:absolute lg:flex bottom-[-150px] left-0 w-[250px] h-[330px]">
        <img src={blueMsg} alt="" />
      </div>
    </div>
  );
};

export default SplashScreen;
